import { Container, Row, Col, Button } from 'react-bootstrap';

const APPLICATION_URL = 'https://forms.gle/UhL2o6w76cCS1Lpy5';

const CareersPage = () => {
  return (
    <>
      <section>
        <Container
          fluid
          className="d-flex justify-content-center bg-secondary-subtle"
        >
          <Row>
            <Col sm={5}>
              <img
                src="/images/bird_views/motivation.webp"
                alt="Dietitian Opportunities"
                className="img-fluid w-100"
                style={{ maxHeight: '400px', objectFit: 'cover' }}
              />
            </Col>
            <Col
              sm={7}
              className="d-flex align-items-center bg-secondary-subtle"
            >
              <h1 className="fw-bold text-center">Dietitian Opportunities</h1>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-light text-body-secondary">
        <Container>
          <h2 className="text-center mb-5">Why Choose Us?</h2>
          <Row className="text-start">
            <Col md={4}>
              <h5 className="fw-bold">Flexibility at Your Fingertips:</h5>
              <p>
                Take control of your work-life balance with complete authority
                over your working schedules. Enjoy the freedom to design your
                days around what matters most to you.
              </p>
            </Col>
            <Col md={4}>
              <h5 className="fw-bold">Remote or In-Person, Your Choice:</h5>
              <p>
                Choose how you want to make an impact—whether it’s face-to-face
                interactions or telehealth consultations, your workspace is what
                you make it.
              </p>
            </Col>
            <Col md={4}>
              <h5 className="fw-bold">Admin Support That Empowers:</h5>
              <p>
                Spend more time doing what you love—seeing patients and making a
                difference. Leave the back-office work to us.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-white text-body-emphasis">
        <Container>
          <h2 className="mb-4">Who We're Looking For</h2>
          <p>
            We are seeking a dedicated and professionally licensed Registered
            Dietitian to join our extensive network of medical company
            partnerships and expand their practice in the dynamic field of
            outpatient dietetics. This is an exceptional opportunity for those
            looking to deepen their career in a supportive network that promotes
            growth and collaboration.
          </p>

          <h5 className="mt-4">Job Title</h5>
          <p>Contract Solo Practice Dietitian or Group Practice</p>

          <h5 className="mt-4">Required Qualifications</h5>
          <ul>
            <li>
              <strong>Registered Dietitian (RD)</strong> verified through the
              Commission on Dietetic Registration (CDR)
            </li>
            <li>Active state license in dietetics</li>
            <li>Completed CAQH profile</li>
            <li>Current malpractice insurance</li>
          </ul>

          <h5 className="mt-4">Compensation Details</h5>
          <ul>
            <li>Competitive hourly rates based on insurance reimbursements</li>
            <li>
              The average compensation rate ranges from{' '}
              <strong>$60 to $90 per hour</strong>, depending on the insurance
              company
            </li>
          </ul>

          <h5 className="mt-4">Application Process</h5>
          <p>
            Interested candidates are encouraged to apply by filling out the
            online application form available on our website. Please ensure that
            all provided information is accurate and up-to-date.
          </p>

          <h5 className="mt-4">Additional Benefits</h5>
          <ul>
            <li>
              <strong>Community Connection:</strong> Avoid the isolation often
              associated with solo practices by joining our community platform.
              Network and share insights with fellow dietitians daily.
            </li>
            <li>
              <strong>Resources at Your Fingertips:</strong> We offer a variety
              of patient handouts, empowering you to provide exceptional care
              and education.
            </li>
            <li>
              <strong>Efficient EMR & Billing Services:</strong> Our
              comprehensive electronic medical records and billing services
              streamline your workflow, allowing you to focus more on patient
              care.
            </li>
          </ul>

          <p className="mt-4">
            Join our team and leverage these valuable resources to enhance your
            professional practice while delivering top-notch dietary guidance to
            patients. We are committed to fostering a community where dietitians
            thrive professionally and personally.
          </p>

          <div className="text-center mt-5">
            <Button
              variant="secondary"
              size="lg"
              onClick={() =>
                window.open(APPLICATION_URL, '_blank', 'noopener,noreferrer')
              }
            >
              Apply Now
            </Button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CareersPage;
